import request from '@/utils/request'
//关于我们
export const getAboutInfo = () => request.get('/official/aboutUs/detail')
